import { styled, Typography } from "@material-ui/core";
import { EPOCUS_TEXT_PRIMARY, rem } from "./epocus-palette";

/**
 * Monospace pill that renders an accession ID for copy-to-machine flows.
 * Shared by the new-encounter form and the awaiting-images empty-state so the
 * copy affordance stays visually consistent across both.
 */
export const AccessionIdDisplay = styled(Typography)({
  fontFamily: "monospace",
  fontSize: rem(14),
  color: EPOCUS_TEXT_PRIMARY,
  backgroundColor: "#f4f4f5",
  borderRadius: 6,
  padding: "6px 10px",
  letterSpacing: "0.05em",
  flex: 1,
  whiteSpace: "normal",
  overflowWrap: "anywhere",
});
